import { LegalLayout, H2, P, UL } from "@/components/LegalLayout";

export default function AvisoLegal() {
  return (
    <LegalLayout title="Aviso legal" updated="Última actualización: septiembre de 2026">
      <div data-testid="legal-aviso">
        <H2>1. Identificación del titular</H2>
        <P>
          El presente sitio web y el servicio DDP · Datos · Decisión · Posición (en adelante, «DDP» o «el servicio») son
          titularidad de un profesional independiente que actúa por cuenta propia, con los siguientes datos identificativos:
        </P>
        <UL>
          <li><strong>Titular:</strong> José Carlos Moraleda García.</li>
          <li><strong>NIF:</strong> 15471973B.</li>
          <li><strong>Domicilio profesional:</strong> Almería, España, 04006.</li>
          <li><strong>Correo electrónico de contacto:</strong> jcmgjurista@gmail.com.</li>
          <li><strong>Teléfono:</strong> +34 627225405.</li>
        </UL>
        <P>
          El titular actúa como profesional individual por cuenta propia. DDP no constituye una sociedad mercantil ni ninguna
          otra entidad con personalidad jurídica propia.
        </P>

        <H2>2. Objeto y ámbito del sitio web</H2>
        <P>
          DDP es un servicio de apoyo a la decisión dirigido a despachos profesionales. Permite solicitar acceso a un piloto,
          remitir de forma segura la documentación de un asunto y recibir, dentro de un área privada autenticada, una Hoja de
          Decisión elaborada con control humano. El servicio ofrece una referencia independiente sobre el expediente y no
          sustituye en ningún caso el criterio profesional del despacho ni constituye asesoramiento jurídico automatizado.
        </P>

        <H2>3. Condiciones de acceso y uso</H2>
        <P>
          El acceso al área privada está reservado a despachos previamente aprobados e invitados; no existe registro público
          abierto. El usuario se compromete a hacer un uso diligente, lícito y conforme a la buena fe del sitio y del servicio,
          a facilitar información veraz y a custodiar debidamente sus credenciales de acceso, que son personales e
          intransferibles. Queda prohibido cualquier uso que pueda dañar, sobrecargar o impedir el normal funcionamiento del
          servicio, así como el acceso no autorizado a áreas o datos de terceros.
        </P>

        <H2>4. Propiedad intelectual e industrial</H2>
        <P>
          Los contenidos del sitio (textos, marca, logotipo, diseño, estructura y demás elementos) pertenecen al titular o a
          terceros que han autorizado su uso, y están protegidos por la normativa de propiedad intelectual e industrial. No se
          autoriza su reproducción, distribución, transformación o comunicación pública sin consentimiento previo y por escrito.
          La documentación aportada por cada despacho continúa siendo titularidad de este.
        </P>

        <H2>5. Responsabilidad por el uso del sitio web</H2>
        <P>
          La Hoja de Pronóstico y cualquier salida del servicio tienen carácter orientativo y de apoyo. La decisión final y su
          ejecución corresponden en exclusiva al despacho, que mantiene su plena responsabilidad profesional. El titular no
          responde de las decisiones adoptadas por el usuario ni de las consecuencias derivadas de un uso indebido del servicio
          o de información incompleta o inexacta facilitada por el usuario.
        </P>

        <H2>6. Disponibilidad e interrupción del servicio</H2>
        <P>
          El titular procura mantener el servicio disponible y operativo, pero no puede garantizar la ausencia de
          interrupciones. El servicio podrá suspenderse temporalmente por razones técnicas, de mantenimiento o de seguridad, o
          por causas ajenas al titular. En la medida de lo posible se avisará de las interrupciones previsibles.
        </P>

        <H2>7. Enlaces externos</H2>
        <P>
          En caso de que el sitio incluya enlaces a páginas de terceros, se ofrecen únicamente a título informativo. El titular
          no controla ni asume responsabilidad sobre los contenidos, políticas o servicios de esos sitios externos.
        </P>

        <H2>8. Legislación aplicable</H2>
        <P>
          El presente aviso legal se rige por la legislación española. Para la resolución de cualquier controversia serán
          competentes los juzgados y tribunales que correspondan conforme a la normativa aplicable.
        </P>

        <H2>9. Contacto para asuntos legales</H2>
        <P>
          Para cualquier cuestión relacionada con este aviso legal puede dirigirse al titular a través del correo electrónico{" "}
          <a href="mailto:jcmgjurista@gmail.com" style={{ color: "var(--burgundy)", fontWeight: 600 }}>jcmgjurista@gmail.com</a>.
        </P>
      </div>
    </LegalLayout>
  );
}
